export default {
  tabs: {
    all: 'All',
    unread: 'Unread',
    read: 'Read',
  },
  actions: {
    markAllRead: 'Mark all as read',
  },
  messages: {
    markAllReadSuccess: 'All marked as read',
  },
  breadcrumb: {
    root: 'Notifications',
  },
  tag: {
    announcement: 'Announcement',
  },
  dateTimeFormat: 'YYYY/MM/DD HH:mm:ss',
}